import React from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, borderRadius, themeLight } from '@naf/theme';
import { Commute } from '@styled-icons/material/Commute';
import { DriveEta } from '@styled-icons/material/DriveEta';
import { LocalGasStation } from '@styled-icons/material/LocalGasStation';
import { propValidationConfig } from '../propValidationConfig';

/*
TODO:
    - Add correct icons
    - Add functionality for placement on images
*/

const renderIcon = icon => {
  switch (icon) {
    case 'commute':
      return /*#__PURE__*/React.createElement(Commute, {
        size: 16
      });
    case 'driveEta':
      return /*#__PURE__*/React.createElement(DriveEta, {
        size: 16
      });
    case 'localGasStation':
      return /*#__PURE__*/React.createElement(LocalGasStation, {
        size: 16
      });
    default:
      return null;
  }
};
export const Label = ({
  text,
  className,
  size = 'default',
  icon,
  customIcon,
  variant = 'white'
}) => {
  return /*#__PURE__*/React.createElement(Tag, {
    size: size,
    variant: variant,
    className: className
  }, icon ? renderIcon(icon) : null, customIcon, text);
};
export default Label;
const Tag = styled.span.withConfig(propValidationConfig).withConfig({
  displayName: "label__Tag",
  componentId: "sc-higpf9-0"
})(["display:inline-flex;justify-content:center;align-items:center;border-radius:", ";svg{margin-right:", ";}", " ", " ", " ", " ", " ", " ", ""], borderRadius.M, spacing.space8, ({
  size
}) => size === 'default' && css(["padding:0 ", " 0 ", ";height:", ";", ""], spacing.space8, spacing.space8, spacing.space24, fontStyle.componentText.tag), ({
  size
}) => size === 'small' && css(["padding:0 ", " 0 ", ";height:", ";", ""], spacing.space4, spacing.space4, spacing.space20, fontStyle.componentText.tagSmall), ({
  variant
}) => variant === 'white' && css(["background:", ";color:", ";"], ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, ({
  theme
}) => theme.typography ? theme.typography.brandText : themeLight.typography.brandText), ({
  variant
}) => variant === 'moss' && css(["background:", ";color:", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondary : themeLight.componentColors.cta.secondary, ({
  theme
}) => theme.typography ? theme.typography.brandText : themeLight.typography.brandText), ({
  variant
}) => variant === 'spruce' && css(["background:", ";color:", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.secondaryInverted : themeLight.componentColors.cta.secondaryInverted, ({
  theme
}) => theme.typography ? theme.typography.brandTextInverted : themeLight.typography.brandTextInverted), ({
  variant
}) => variant === 'signature' && css(["background:", ";color:", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.cta.primary : themeLight.componentColors.cta.primary, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText), ({
  variant
}) => variant === 'info' && css(["background:", ";color:", ";"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.infoLight : themeLight.componentColors.alert.infoLight, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText));
//# sourceMappingURL=label.js.map